export default __webpack_public_path__ + "static/media/litho-landing-page-bg-img-01.e46d0640.jpg";